const r = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#x27;",
  "`": "&#x60;",
  "=": "&#x3D;"
}, e = /[&<>"'`=]/, i = /[&<>"'`=]/g;
function s(t) {
  return r[t];
}
function c(t) {
  let n;
  if (typeof t != "string") {
    if (t == null)
      return "";
    if (!t)
      return String(t);
    n = String(t);
  } else
    n = t;
  return e.test(n) ? n.replace(i, s) : n;
}
export {
  c as escape
};
